import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { aiAssistant } from '@/mocks/smart-farm';

export default function AIAssistant() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="AI 助手"
          title={aiAssistant.title}
          subtitle={aiAssistant.desc}
        />

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* 左：聊天界面模拟 */}
          <Reveal className="w-full order-2 lg:order-1">
            <div className="rounded-2xl bg-foreground-950 border border-background-200 p-5">
              <div className="flex items-center gap-3 pb-4 border-b border-background-50/10">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950 shrink-0">
                  <i className="ri-robot-2-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-background-50">TOMA 智能体</div>
                  <div className="text-[11px] text-foreground-400">农场统一智能服务入口</div>
                </div>
              </div>

              <div className="mt-4 space-y-3">
                {aiAssistant.chat.map((msg, idx) => (
                  <div
                    key={idx}
                    className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}
                  >
                    <div
                      className={`max-w-[85%] px-4 py-2.5 rounded-lg text-sm leading-relaxed ${
                        msg.role === 'user'
                          ? 'bg-accent-500 text-foreground-950 rounded-br-sm'
                          : 'bg-background-50/10 text-background-100 rounded-bl-sm'
                      }`}
                    >
                      {msg.text}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <p className="mt-3 text-center text-[11px] text-foreground-400">
              对话为产品能力示意，示例内容经过脱敏处理
            </p>
          </Reveal>

          {/* 右：功能场景 */}
          <div className="w-full order-1 lg:order-2">
            <div className="flex flex-col gap-4">
              {aiAssistant.scenarios.map((scenario) => (
                <div
                  key={scenario.title}
                  className="flex items-start gap-4 p-5 rounded-lg bg-background-100 border border-background-200 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 shrink-0">
                    <i className={`${scenario.icon} text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-foreground-950 text-base">
                      {scenario.title}
                    </h3>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{scenario.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 flex items-start gap-3 p-5 rounded-lg bg-background-100 border border-accent-200">
              <i className="ri-user-heart-line text-accent-600 text-xl mt-0.5 shrink-0"></i>
              <p className="text-sm text-foreground-800 leading-relaxed">{aiAssistant.note}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}